import { render, staticRenderFns } from "./BindsDialog.vue?vue&type=template&id=216aa0a7&"
import script from "./BindsDialog.vue?vue&type=script&lang=js&"
export * from "./BindsDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindsDialog.vue?vue&type=style&index=0&id=216aa0a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports